import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";

import { RoleAccessService } from "@bitwarden/web-vault/app/services/permission/role-access.service";
import { GlossRoutes } from "@bitwarden/web-vault/app/models/enum/routes.enum";

/**
 * BETA_ACCESS only. Prevents URL bypass to the organizations (teams) route.
 * Backend enforces authorization independently; this guard is cosmetic (early feature access).
 */
@Injectable({
  providedIn: "root",
})
export class OrganizationsGuard implements CanActivate {
  constructor(
    private router: Router,
    private roleAccess: RoleAccessService,
  ) {}

  canActivate(): boolean | UrlTree {
    if (!this.roleAccess.isBetaUser()) {
      return this.router.createUrlTree(["/", GlossRoutes.Views]);
    }
    return true;
  }
}
